import { $ } from './../helpers/query'

export default class {
  constructor() {
    this.animStartClass = 'mobile-anim--start';
    this.animatedElems = $(`.${this.animStartClass}`);
  }

  bindEvents() {
    this.showElems()
    window.addEventListener('scroll', () => {
      this.showElems()
    })
  }

  showElems() {
    this.animatedElems.each((elem) => {
      const top = elem.getBoundingClientRect().top;
      const height = document.documentElement.clientHeight;
      if (top < height * 6/7) {
        elem.classList.remove(this.animStartClass)
      }
    })
  }
}
